import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../flux';
import { images, texts } from '../../settings';
import { DelayLink } from '../../components';

import './SobreRelatorio.scss';

class SobreRelatorio extends Component {
  constructor(props) {
    super(props);

    this.state = {
      width: window.innerWidth,

      loaderBarWidth: 0,
      loaderBarIndex: 0,
      intervalBar: 0,
    };

    this.images = images;
    this.texts = texts;

    this.contentText = React.createRef();
    this.runTransition = this.runTransition.bind(this);

    this.startLoader = this.startLoader.bind(this);
    this.loaderBar = this.loaderBar.bind(this);
  }

  scrollTop() {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  }

  runTransition() {
    Actions.globalTransition();
  }

  loaderBar() {
    const { loaderBarIndex } = this.state;
    let index = loaderBarIndex;
    index++;
    if (index <= 100) {
      this.setState({
        loaderBarIndex: index,
        loaderBarWidth: index + '%',
      });
    } else {
      clearInterval(this.state.intervalBar);
    }
  }

  startLoader() {
    this.setState({ loaderBarIndex: 0 });
    var intervalBar = setInterval(this.loaderBar, percent);
    this.setState({ intervalBar: intervalBar });
  }

  componentDidMount() {
    Actions.headerIntern();
    this.scrollTop();
  }

  render() {
    const { loaderBarWidth } = this.state;

    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Sobre o Relatório - {this.texts.title}</title>
        </Helmet>

        <div className="parallax-image">
          <img src={this.images.sobre_relatorio.first_bg} />
        </div>

        <div className="sobre-relatorio" ref="sobre-relatorio">
          <section className="sobre-relatorio-area page--blue">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="card card--page-body card--blue">
                      <div className="card__content">
                        <div className="card__content__header">
                          <h1 className="title">Sobre o relatório</h1>
                        </div>
                        <div className="card__content__body">
                          <p className="gri_text gri_text_sobre_relatorio">
                            A versão online que você está acessando é a única deste relatório anual – não temos uma
                            edição impressa. Por aqui, você encontra informações sobre nossa governança, estratégia,
                            equipe interna, além das principais iniciativas que tocamos entre 1º de janeiro e 31 de
                            dezembro de 2019.
                            <span className="gri_label">
                              GRI <b>102-46, 102-50, 102-52</b>
                            </span>
                          </p>
                          <p className="gri_text gri_text_sobre_relatorio">
                            Esta edição, assim como as duas anteriores, é inspirada na GRI (Global Reporting
                            Initiative), principal metodologia internacional para relatos de sustentabilidade (estamos
                            enquadrados na versão standard, opção essencial).
                            <span className="gri_label">
                              GRI <b>102-54</b>
                            </span>
                          </p>
                          <p className="gri_text gri_text_sobre_relatorio max_width">
                            Do ano passado para cá, não tivemos mudanças significativas em porte, estrutura, cadeia de
                            fornecedores, escopo ou limites do relatório, nem revisões nas informações que estavam na
                            edição anterior – lançada em março de 2019, referente a 2018.
                            <span className="gri_label">
                              GRI <b>102-10, 102-48, 102-49, 102-51</b>
                            </span>
                          </p>
                          <p className="gri_text gri_text_sobre_relatorio">
                            A identificação dos temas prioritários para a ANBIMA é feita a partir de um conjunto de iniciativas e
                            pesquisas com vários dos nossos públicos de interesse. Não se trata de um processo único ou de uma
                            pesquisa formal, mas sim de ações permanentes, muitas delas calcadas na nossa própria governança.
                            Afinal, os trabalhos desenvolvidos pelos fóruns de representação nos permitem ouvir o mercado e
                            identificar o que ele espera da nossa atuação. Também fazemos consultas periódicas com os
                            reguladores.
                            <br/><br/>
                            Ao longo de 2019, além desse diálogo constante, tivemos diversas pesquisas com stakeholders,
                            que nos permitiram uma visão mais ampla de seus interesses e prioridades. Foi o caso do 
                            levantamento feito pela Accenture para definir a nova governança e do trabalho da Oliver
                            Wyman, que entrevistou players do mercado para construção de uma agenda de propostas
                            para o fortalecimento do mercado de capitais. Paralelamente, conduzimos um trabalho com
                            a EY sobre inovação para entender qual deveria ser o posicionamento da ANBIMA em relação
                            ao tema. Por fim, anualmente traçamos um raio X do investidor brasileiro para conhecer
                            seus hábitos e percepções em relação a investimento.
                            <span className="gri_label">
                              GRI <b>102-42, 102-43, 102-46</b>
                            </span>
                          </p>
                        </div>
                      </div>
                      <div className="card__image">
                        <img src={images.sobre_relatorio.second_bg} />
                      </div>
                    </div>
                  </Fade>
                  <Fade bottom>
                    <div
                      className="sobre-relatorio-duvidas"
                      style={{
                        backgroundImage: 'url(' + this.images.sobre_relatorio.third_bg + ')',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                      }}
                    >
                      <div className="sobre-relatorio-duvidas__container">
                        <div className="sobre-relatorio-duvidas__image">
                          <img
                            className="sobre-relatorio-duvidas__image-main"
                            src={this.images.sobre_relatorio.pessoa1}
                          />
                          <img
                            className="sobre-relatorio-duvidas__image-bg1"
                            src={this.images.sobre_relatorio.fundo_pessoa1_1}
                          />
                          <img
                            className="sobre-relatorio-duvidas__image-bg2"
                            src={this.images.sobre_relatorio.fundo_pessoa1_2}
                          />
                        </div>
                        <div className="sobre-relatorio-duvidas__text">
                          <p>
                            Tem alguma dúvida? <span>Fale com a gente pelo</span>
                          </p>
                          <a href="mailto:imprensa@anbima.com.br">imprensa@anbima.com.br</a>
                          <br />
                          <span className="gri_label">
                            GRI <b>102-53</b>
                          </span>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className="creditos-area">
            <div className="container">
              <div className="row">
                <div className="col-12 creditos-area__title">
                  <Fade bottom>
                    <h2>
                      <span className="monster bordered_text bordered_text--dark-gray">Créditos</span>
                      <span className="creditos-area__title_sub">
                        conheça quem fez
                        <br />
                        esta publicação:
                      </span>
                    </h2>
                  </Fade>
                </div>

                <div className="col-4-sobre-relatorio">
                  <Fade bottom>
                    <div className="card card--blue">
                      <div className="card__content card__content--full">
                        <div className="card__content__header card__content__header--no-border">
                          <img src={this.images.sobre_relatorio.icon_gerencia} className="card__icon" />
                          <h3 className="title title--small">Marcelo Billi</h3>
                        </div>
                        <div className="card__content__body">
                          <p>Gerência de Comunicação e Marketing</p>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>

                <div className="col-4-sobre-relatorio">
                  <Fade bottom>
                    <div className="card card--blue">
                      <div className="card__content card__content--full">
                        <div className="card__content__header card__content__header--no-border">
                          <img src={this.images.sobre_relatorio.icon_coord_conteudo} className="card__icon" />
                          <h3 className="title title--small">Marineide Marques</h3>
                        </div>
                        <div className="card__content__body">
                          <p>Coordenação de comunicação</p>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>

                <div className="col-4-sobre-relatorio">
                  <Fade bottom>
                    <div className="card card--blue">
                      <div className="card__content card__content--full">
                        <div className="card__content__header card__content__header--no-border">
                          <img src={this.images.sobre_relatorio.icon_redacao} className="card__icon" />
                          <h3 className="title title--small">Flávia Nosralla</h3>
                        </div>
                        <div className="card__content__body">
                          <p>Redação</p>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>

                <div className="col-4-sobre-relatorio">
                  <Fade bottom>
                    <div className="card card--blue">
                      <div className="card__content card__content--full">
                        <div className="card__content__header card__content__header--no-border">
                          <img src={this.images.sobre_relatorio.icon_coord_digital} className="card__icon" />
                          <h3 className="title title--small">Amanda Brum</h3>
                        </div>
                        <div className="card__content__body">
                          <p>Coordenação digital</p>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>

                <div className="col-4-sobre-relatorio">
                  <Fade bottom>
                    <div className="card card--blue">
                      <div className="card__content card__content--full">
                        <div className="card__content__header card__content__header--no-border">
                          <img src={this.images.sobre_relatorio.icon_edicao} className="card__icon" />
                          <h3 className="title title--small">Carlos Oliveira</h3>
                        </div>
                        <div className="card__content__body">
                          <p>Edição digital</p>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>

                <div className="col-4-sobre-relatorio">
                  <Fade bottom>
                    <div className="card card--blue">
                      <div className="card__content card__content--full">
                        <div className="card__content__header card__content__header--no-border">
                          <img src={this.images.sobre_relatorio.icon_projeto} className="card__icon" />
                          <h3 className="title title--small">
                            <img src={this.images.sobre_relatorio.logo_creditos_fullbar} />
                          </h3>
                        </div>
                        <div className="card__content__body">
                          <p>Projeto digital</p>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>

          <section className="sobre-footer-area">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade>
                    <div className="box-pill box-pill--green box-pill--center">
                      <div className="box-pill__content box-pill__content--full">
                        <div className="row">
                          <div className="col col-8 col--text">
                            <h4>Entenda o sumário de conteúdo GRI</h4>
                            <DelayLink
                              to="/sumario-gri"
                              className="button button--aylen button--white-to-green button--border-medium button--size-m button--round-l button--text-thick"
                            >
                              Saiba mais
                            </DelayLink>
                          </div>
                          <div className="col col-4">
                            <img
                              src={this.images.sumario.sumario_hero}
                              className="pessoa_destaque pessoa_destaque--1"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

export { SobreRelatorio };
